<button [ngClass]="getButtonClasses() + ' ' + getSizeClasses()" 
        [disabled]="disabled()"
        [attr.aria-label]="ariaLabel() || label()"
        (click)="onButtonClick()"><span [ngClass]="{
            'mr-2': arrow() === 'right' || arrow() === 'bottom' || arrow() === 'top'
        }" class="flex items-center relative z-10 font-inter" [class.text-white]="color() === 'white'"
        [class.text-black]="color() === 'black'" style="--x: 0;">
        {{label()}}
    </span>

    <svg xmlns="http://www.w3.org/2000/svg" [attr.width]="getIconSize().width" [attr.height]="getIconSize().height"
        viewBox="0 0 24 24" fill="none" class="self-center relative z-10" style="--x: 20;">
        <path [attr.fill]="color() === 'white' ? 'white' : 'black'" [attr.d]="getArrowPath()" />
    </svg>
</button>